import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';

import { Card } from 'antd';
import ModelForm from './ModelForm';
import DeliveryPointDetailActions from '../../Stores/DeliveryPointDetail/Actions';

class DeliveryPointDetailScreen extends React.PureComponent {
  componentDidMount() {
    const { match, setReslId } = this.props;

    if (match.params.action === 'create') {
      setReslId(0);
    } else if (match.params.action === 'update') {
      setReslId(parseInt(match.params.id, 10));
    }
  }

  componentDidUpdate() {}

  componentWillUnmount() {}

  render() {
    const { intl, match, model } = this.props;

    return (
      <Card title={`${intl.formatMessage({ id: 'delivery_point' })} ${model.code}`}>
        <ModelForm match={match} />
      </Card>
    );
  }
}

DeliveryPointDetailScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  setReslId: PropTypes.func,
  model: PropTypes.shape({
    code: PropTypes.string,
    status: PropTypes.number
  })
};

DeliveryPointDetailScreen.defaultProps = {
  intl: {},
  match: {},

  setReslId() {},
  model: { code: '', status: 2 }
};

const mapStateToProps = state => ({
  model: state.deliveryPointDetail.model
});

const mapDispatchToProps = dispatch => ({
  setReslId: resId => dispatch(DeliveryPointDetailActions.deliveryPointDetailSetResId(resId))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DeliveryPointDetailScreen));
